export default __webpack_public_path__ + "assets/warning.0a2b.svg";